module.exports = __webpack_public_path__ + "static/media/play.e989bdee.svg";